<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col>
                    <EngagementNav></EngagementNav>
                </b-col>
          </b-row>
        </div>
        <div>
            <div class="engagement-body">
                <b-row>
                    <b-col sm="12" md="8" class="pr-md-0">
                        <div class="engagement-content">
                            <b-row no-gutters>
                                <b-col cols="12">
                                    <div class="d-inline-block mr-3 align-top">
                                        <b-input-group>
                                            <b-input-group slot="append">
                                                <i class="icon-calendar" style="cursor: pointer" data-toggle @click="openRangePicker"></i>
                                                <i class="icon-clear" style="cursor: pointer" data-toggle @click="clearRangePicker"></i>
                                            </b-input-group>
                                            <datepicker :config="daterangeConfig" placeholder="Select date">
                                            </datepicker>
                                        </b-input-group>
                                    </div>
                                    <div id="news-search-bar" class="d-inline-block">
                                        <div class="filter-wrapper">
                                            <b-input-group prepend=" ">
                                                <b-form-input placeholder="Search" v-on:input="search(true)"
                                                              v-model="searchString"></b-form-input>
                                                <b-dropdown text="Advanced" variant="primary" slot="append">
                                                    <b-dropdown-item v-for="(category, index) in categories" :value="index" @click="searchOption(index)" :key="`category_${index}`">
                                                        {{ category}}
                                                        <i v-if="selectedSearchOption ==  index" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                                        </i>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </b-input-group>
                                        </div>
                                    </div>
                                    <b-button variant="primary" class="ml-3 d-inline-block new-button align-top" disabled>
                                        + News
                                    </b-button>
                                    <AddNews :image="form.image" @clearImage="clearNewsImg"></AddNews>
                                    <b-modal id="newsUploadImage" title="Upload Image">
                                        <div id="news-image-upload-container" class="border mx-auto">
                                            <croppa 
                                                v-model="croppa"
                                                @new-image-drawn="onNewImage"
                                                @zoom="onZoom"
                                                :width="360"
                                                :height="360"
                                                placeholder="Choose an Image"
                                                :show-remove-button="true"
                                                :placeholder-font-size="14"
                                                remove-button-color="#ff8828">
                                            </croppa>
                                        </div>
                                        <div id="news-image-range-container" class="mx-auto mt-2">
                                            <input type="range" class="custom-range" id="customRange1" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal">
                                        </div>
                                        <div slot="modal-footer">
                                            <b-button variant="ghost" class="btn-cancel" @click="hideUploadImageModal(true)" style="margin-right: .25rem;">
                                                Cancel
                                            </b-button>
                                            <b-button variant="primary" @click="hideUploadImageModal(true)" style="margin-left: .25rem;">
                                                Save
                                            </b-button>
                                        </div>
                                    </b-modal>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col sm="12" md="12" class="pl-md-0 pr-md-0"></b-col>
                </b-row>
                <template v-if="news.length > 0">
                    <b-row class="mt-3" no-gutters>
                        <b-col>
                            <div>
                                <b-card-group deck>
                                    <b-card class="news-container" v-for="(item, index) in news" :key="`news_${index}`">
                                        <b-row no-gutters>
                                            <b-col class="align-middle">
                                                <h5 class="d-inline-block mb-0">{{ currentFirstItem + index}}</h5>
                                            </b-col>
                                            <b-col class="text-right align-middle">
                                                <!--<img src="../../assets/images/actions/search.svg" alt="Search Button" class="action-button" @click="callDisplay(item.uuid)">-->
                                                <img src="../../assets/images/actions/edit.svg" alt="Edit Button" class="action-button ml-1 not-enabled">
                                                <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="action-button ml-1" @click="callDelete(item.uuid, item.title)">
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <div class="banner mt-2">
                                                    <img :src="item.image" alt="">
                                                </div>
                                                <h6 class="news-title mb-0">{{ item.title }}</h6>
                                                <div class="mx-auto mt-3 inactive-expired" v-if="item.status.toLowerCase() == 'in-active' || item.status.toLowerCase() == 'expired'">{{ item.status}}</div>
                                                <div class="mx-auto mt-3" v-else v-bind:class="[item.status.toLowerCase()]">{{ item.status}}</div>
                                                <p class="scheduled-date text-center">{{ item.publish_date}}</p>
                                                <p class="selected-audience text-center">All Registered Users</p>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                    <template v-if="news.length < 4">
                                        <b-card class="blank-news" v-for="index in (4 - news.length)" :key="index">
                                        </b-card>
                                    </template>
                                </b-card-group>
                            </div>
                        </b-col>
                        <b-col cols="1">
                            <img class="news-add-button d-block mx-auto not-enabled" src="../../assets/images/icons/add.svg" alt="Add Icon">
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="news-pagination-container mt-4 mx-auto">
                                <!--<div class="page active mx-1 d-inline-block rounded-circle" v-if="currentPage"></div>-->
                                <div class="page mx-1 d-inline-block rounded-circle" v-for="(n,index) in maxPage" @click="paginate(n)" v-bind:class="{active: n == currentPage}" :key="`page_${index}`"></div>
                            </div>
                        </b-col>
                    </b-row>
                </template>
                <template v-else>
                    <b-row>
                        <b-col>
                            <div class="empty-add-news text-center mt-3">
                                <h2>Create News</h2>
                                <img class="add-button d-block mx-auto mt-2 not-enabled" src="../../assets/images/icons/add.svg" alt="Add Icon">
                            </div>
                        </b-col>
                    </b-row>
                </template>
            </div>
        </div>
        <b-modal id="search-modal" :title="newsDetails.title">
            <div>
                <b-img fluid :src="newsDetails.image" alt="Sample Badge" />
            </div>
            <div slot="modal-footer">
                <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('search-modal')">
                    Cancel
                </b-btn>
                <b-btn variant="primary" class="ml-1" @click="hideModal('search-modal')">
                    OK
                </b-btn>
            </div>
        </b-modal>
            <EditNews :form="newsDetails" :image="form.image"></EditNews>
        <b-modal id="delete-modal" title="Confirm Delete">
            <p class="modal-main-message">Are you sure you want delete this item:</p>
            <h3 class="modal-secondary-message">{{ this.deleteName }}</h3>
            <div slot="modal-footer">
                <b-btn variant="ghost" v-bind:disabled="loading" class="mr-1 btn-cancel" @click="hideModal('delete-modal')">
                    Cancel
                </b-btn>
                <b-btn variant="primary" v-bind:disabled="loading" class="ml-1" @click="deleteNews">
                    <template v-if="loading">
                        Deleting...
                    </template>
                    <template v-else>
                        Yes, Delete
                    </template>
                </b-btn>
                <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
            </div>
        </b-modal>
        <b-modal id="prompt-modal" content-class="py-4" size="lg" hide-header centered >
            <div class="h5 font-weight-bold text-center text-primary">
                News has moved to the News &amp; Pop up tab.
            </div>
            <div class="h5 text-center mt-3">
                All settings for news announcements and other pop-up notifications are now found under a single News &amp; Pop up sub-module.
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" @click="hideModal('prompt-modal')">
                    OK
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Switches from "vue-switches";
import EngagementNav from "./EngagementNav.vue";
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import { mapState } from "vuex";
import AddNews from "./AddNews";
import EditNews from "./EditNews";

export default {
    name: "news",
    data() {
        return {
            form: {
                selectedBroadcast: "all",
                broadcastOptions: [{ value: "all", text: "All Broadcasts" }],
                image: ""
            },
            fields: [
                { key: "referenceNo", label: "Reference No.", sortable: true },
                { key: "newsTitle", sortable: true },
                { key: "status", sortable: true },
                { key: "dateCreated", sortable: true },
                { key: "id", label: "Action" }
            ],
            perPage: 5,
            scheduledTime: {
                HH: "10",
                mm: "00",
                ss: "00"
            },
            croppa: {},
            sliderVal: 0,
            sliderMin: 0,
            sliderMax: 0,
            selectedSearchOption: "0",
            searchString: "",
            deleteName: "",
            deleteUuid: "",
            rangePicker: null
        };
    },
    components: {
        EngagementNav,
        Switches,
        Datepicker,
        VueEditor,
        SingleDatepicker,
        VueTimepicker,
        AddNews,
        EditNews
    },
    computed: {
        ...mapState("news", [
            "news",
            "newsDetails",
            "nextPage",
            "prevPage",
            "maxPage",
            "currentPage",
            "totalPerPage",
            "searching",
            "categories",
            "loading",
            "editing",
            "currentFirstItem",
            "currentLastItem",
            "customerNames",
            "errors"
        ]),
        daterangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    // defaultDate: ["today", "today"],
                    onChange: function(selectedDates) {
                        _this.selectedDate(selectedDates);
                        _this.range = selectedDates;
                    },
                    onReady: function(selectedDates, dateStr, instance) {
                        _this.rangePicker = instance;
                    }
                };
            }
        }
    },
    async created() {
        await this.getNews(1);
        this.getCategories();
        this.$root.$emit("bv::show::modal", "prompt-modal");
    },
    methods: {
        async getNews(page) {
            await this.$store.dispatch("news/getNews", page);
        },
        getCategories() {
            this.$store.dispatch("news/getCategories");
        },
        paginate(page) {
            if (this.searching) {
                return this.search(false, page);
            }

            return this.getNews(page);
        },
        search(newSearch = false, page) {
            let param = this.getSearchParams(newSearch, page);

            if (this.searchString.trim() === "") {
                return this.getNews(1);
            }

            this.$store.dispatch("news/search", param);
        },
        getSearchParams(newSearch, page) {
            let range = null;

            if (this.range != null) range = this.getRange(this.range);

            let param = {
                apiFields: {
                    category: this.selectedSearchOption,
                    text: [this.searchString],
                    filter: range
                },
                page: newSearch === true ? 1 : page
            };

            return param;
        },
        selectedDate(value) {
            let range = {};

            if (value.length == 2) {
                range = this.getRange(value);

                this.filterDate(range, this.currentPage);
            }
        },
        getRange(value) {
            this.range = value;

            let range = {
                start: this.$moment(value[0]).format("YYYY-MM-DD"),
                end: this.$moment(value[1]).format("YYYY-MM-DD")
            };

            return range;
        },
        filterDate(range, page = 1) {
            let param = this.getSearchParams(true, page);

            this.$store.dispatch("news/search", param);
        },
        callDelete(uuid, title) {
            this.deleteName = title;
            this.deleteUuid = uuid;
            this.showModal("delete-modal");
        },
        async callDisplay(uuid) {
            let _this = this;

            this.$store.dispatch("news/editing");

            await this.$store.dispatch("news/viewNews", uuid).then(function() {
                _this.showModal("edit-modal");
            });
        },
        deleteNews() {
            let _this = this;

            this.$store
                .dispatch("news/deleteNews", this.deleteUuid)
                .then(function() {
                    _this.hideModal("delete-modal");

                    if (_this.errors == null) _this.getNews(_this.currentPage);
                });
        },
        hideModal(modal) {
            if (modal == "delete-modal") {
                this.deleteName = "";
                this.deleteUuid = "";
            }

            this.$root.$emit("bv::hide::modal", modal);
        },
        async showModal(modal) {
            (await (modal == "edit-modal"))
                ? this.$store.dispatch("news/editing")
                : this.$store.dispatch("news/resetEditing");

            this.$store.dispatch("news/resetErrors");

            this.$root.$emit("bv::show::modal", modal);
        },
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        onNewImage() {
            this.sliderVal = this.croppa.scaleRatio;
            this.sliderMin = this.croppa.scaleRatio / 2;
            this.sliderMax = this.croppa.scaleRatio * 2;
        },
        onSliderChange(evt) {
            var increment = evt.target.value;
            this.croppa.scaleRatio = +increment;
        },
        onZoom() {
            this.sliderVal = this.croppa.scaleRatio;
        },
        onSelectPost(record) {
            for (var i = 0; i < this.posts.length; i++) {
                this.posts[i]._rowVariant = "";
            }
            this.posts[record - 1]._rowVariant = "selected";
        },
        hideUploadImageModal(forceClose = false) {
            if (this.croppa.generateDataUrl() === "") {
                return false;
            }

            this.form.image = this.croppa.generateDataUrl();

            if (forceClose) {
                this.hideModal("newsUploadImage");

                this.editing
                    ? this.showModal("edit-modal")
                    : this.showModal("send-new-news");
            }

            return true;
        },
        openRangePicker() {
            if (this.rangePicker != null) {
                this.rangePicker.toggle();
            }
        },
        clearRangePicker() {
            if (this.rangePicker === null) {
                return false;
            }
            this.rangePicker.clear();
            this.search(true, 1);
        },
        clearNewsImg: function() {
            this.form.image = "";
        }
    }
};
</script>

<style lang="scss" scoped>
.icon-clear {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: text-bottom;
    background: transparent url("../../assets/images/actions/clear.svg")
        no-repeat center / 20px;
}
.not-enabled {
    opacity: 0.65;
    cursor: default;
}
</style>
